export const CheckIfUserInProject = ({ employeesIds, projectId, allProjects, allEmployees }) => {
    console.log(employeesIds, projectId, allProjects, allEmployees);
  
    // Return early if any value is missing.
    if (!employeesIds || !allProjects || !projectId || !allEmployees) {
      console.log("Not all values were provided");
      return;
    }
  
    // Find the project by ID.
    const project = allProjects.find((p) => p._id === projectId);
    if (!project) {
      console.log("Project not found");
      return;
    }
    console.log("project ----> ", project);
  
    // Ensure project.employees is always an array.
    const projectEmployees = Array.isArray(project.employees) ? project.employees : [];
  
    // Filter out employee IDs that are not in the project's employees.
    const notIncludedEmployeesIds = employeesIds.filter(
      (employeeId) => !projectEmployees.includes(employeeId)
    );
  
    // Map those IDs to their employee objects.
    const notIncludedEmployees = notIncludedEmployeesIds.map((employeeId) =>
      allEmployees.find((e) => e._id === employeeId)
    );
  
    console.log("employees not included in the project --> ", notIncludedEmployees);
    return notIncludedEmployees;
  };
  